import { createApp } from 'vue';
import FreeD1D9 from '../../free/D1D9.vue'

const appElements = document.querySelectorAll('.vue-free-d1d9')

Array.from(appElements).forEach(element => {
  createApp(FreeD1D9).mount(element);
});